export default "__VITE_ASSET__DGkiZ2JD__"